export function addScrollPadding(){
    if (!document.body.style.paddingRight) {
        document.body.style.paddingRight = `${window.innerWidth - document.body.offsetWidth}px`;
    }
}

export function removeScrollPadding(){
    document.body.style.removeProperty('padding-right');
}
